const apiConfig = {
  REACT_APP_WS: "https://vm.lab.vistar.ru/ws",
  REACT_APP_VK_APP_ID: "51798451",
  // Имя бота MAX для deep link (переопределяется через .env или runtime)
  REACT_APP_MAX_BOT_NAME: "id3665095544_bot",
  REACT_APP_API: "https://vm.lab.vistar.ru/api",
  REACT_APP_MAINTENANCE: process.env.REACT_APP_MAINTENANCE || '',
  REACT_APP_AI_FILES_BASE_URL: "https://vm.lab.vistar.ru",
  REACT_APP_AI_FILES_PREFIX: "/api/v1/ai/files/*,/api/v1/vstorage/files/*",
};

export default apiConfig;
